import { lazy } from 'react';
import {
  COURSES,
  MESSAGES,
  MESSAGES_ROUTES,
  MY_ACCOUNT_PROFILE,
  MY_ACCOUNT_ROUTES,
  MY_APPOINTMENTS,
  MY_APPOINTMENT_ROUTES,
  MY_SKIN_ROUTES,
  NOTIFICATIONS,
  NOTIFICATIONS_ROUTES,
  PROVIDERS,
  PROVIDERS_ROUTES,
  TEST_KITS_MANAGEMENT,
  TEST_KITS_MANAGEMENT_ROUTES,
  DASHBOARD,
  MY_PROFILE_ACCOUNT_SETTINGS,
  CREATE_CHILD,
  PROVIDERS_PAST_PROVIDERS,
  PROVIDERS_FIND_A_PROVIDER,
  MY_APPOINTMENTS_SCHEDULE_AN_APPOINTMENT,
  TEST_KITS_MANAGEMENT_TEST_KITS,
  MY_SKIN_MY_VISIT_SUMMARIES,
  MY_SKIN_MY_MEDICATION_HISTORY,
} from 'utilities/routes';

export const loadDashboard = () =>
  import('../../app/dashboard/pages/Dashboard');
export const loadMessages = () =>
  import('app/messages/routes/ProviderMessages');
export const loadManageTestKits = () =>
  import('../../app/manage-test-kits/routes/ManageTestKitsRoutes');
export const loadCourses = () => import('../../app/courses');
export const loadCreateChild = () =>
  import('../../app/my-account/pages/add-child');
export const loadNotifications = () =>
  import('../../app/notifications/routes/NotificationsRoutes');
export const loadMyAppointments = () =>
  import('../../app/my-appointments/routes/MyAppointmentsRoutes');
export const loadProvidersViewSelection = () =>
  import(
    '../../app/providers-view-selection/routes/ProvidersViewSelectionRoutes'
  );

export const loadMySkin = () =>
  import('../../app/my-skin/routes/MySkinRoutes').then((module) => ({
    default: module.MySkinRoutes,
  }));

export const loadMyAccount = () =>
  import('../../app/my-account/routes/MyAccountRoutes').then((module) => ({
    default: module.MyAccountRoutes,
  }));

export const DashboardPage = lazy(loadDashboard);
export const MyMessagesRoutes = lazy(loadMessages);
export const ManageTestKitsRoutes = lazy(loadManageTestKits);
export const CoursesRoutes = lazy(loadCourses);
export const CreateChild = lazy(loadCreateChild);
export const NotificationsRoutes = lazy(loadNotifications);
export const MyAppointmentsRoutes = lazy(loadMyAppointments);
export const ProvidersViewSelectionRoutes = lazy(loadProvidersViewSelection);
export const MySkinRoutes = lazy(loadMySkin);
export const MyAccountRoutes = lazy(loadMyAccount);

type LoaderFn = () => Promise<unknown>;

const PREFETCH_GROUPS: [Array<string | undefined>, LoaderFn][] = [
  [['dashboard', DASHBOARD], loadDashboard],
  [
    [
      'my-skin',
      MY_SKIN_ROUTES,
      MY_SKIN_MY_VISIT_SUMMARIES,
      MY_SKIN_MY_MEDICATION_HISTORY,
    ],
    loadMySkin,
  ],
  [
    [
      'manage-test-kits',
      TEST_KITS_MANAGEMENT,
      TEST_KITS_MANAGEMENT_ROUTES,
      TEST_KITS_MANAGEMENT_TEST_KITS,
    ],
    loadManageTestKits,
  ],
  [
    [
      'my-appointments',
      MY_APPOINTMENTS,
      MY_APPOINTMENT_ROUTES,
      MY_APPOINTMENTS_SCHEDULE_AN_APPOINTMENT,
    ],
    loadMyAppointments,
  ],
  [
    [
      'providers',
      PROVIDERS,
      PROVIDERS_ROUTES,
      PROVIDERS_PAST_PROVIDERS,
      PROVIDERS_FIND_A_PROVIDER,
    ],
    loadProvidersViewSelection,
  ],
  [['courses', 'education', COURSES], loadCourses],
  [['messages', MESSAGES, MESSAGES_ROUTES], loadMessages],
  [['notifications', NOTIFICATIONS, NOTIFICATIONS_ROUTES], loadNotifications],
  [
    [
      'my-account',
      MY_ACCOUNT_PROFILE,
      MY_ACCOUNT_ROUTES,
      MY_PROFILE_ACCOUNT_SETTINGS,
      CREATE_CHILD,
    ],
    loadMyAccount,
  ],
];

const PREFETCH_MAP = new Map<string, LoaderFn>();

PREFETCH_GROUPS.forEach(([triggers, load]) => {
  triggers.forEach((trigger) => {
    if (trigger) {
      PREFETCH_MAP.set(trigger.toLowerCase(), load);
    }
  });
});

export const prefetchPatientRoute = (pathOrKey?: string) => {
  if (!pathOrKey) return;
  PREFETCH_MAP.get(pathOrKey.toLowerCase())?.();
};
